// Small pure helpers for the UI; tested in format.test.mjs.

export const relativeTime = (iso: string, now: Date = new Date()): string => {
  const ms = now.getTime() - Date.parse(iso);
  if (!Number.isFinite(ms)) return "";
  const s = Math.round(ms / 1000);
  if (s < 45) return "just now";
  const m = Math.round(s / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.round(m / 60);
  if (h < 36) return `${h}h ago`;
  const d = Math.round(h / 24);
  if (d < 30) return `${d}d ago`;
  return new Date(iso).toLocaleDateString();
};

// Offset of a breadcrumb from the capture moment, e.g. "-1.204s", "+0.010s".
export const offsetLabel = (iso: string, originIso: string): string => {
  const ms = Date.parse(iso) - Date.parse(originIso);
  if (!Number.isFinite(ms)) return "";
  const sign = ms < 0 ? "-" : "+";
  const abs = Math.abs(ms);
  if (abs >= 60_000) return `${sign}${Math.floor(abs / 60_000)}m${Math.round((abs % 60_000) / 1000)}s`;
  return `${sign}${(abs / 1000).toFixed(3)}s`;
};

export const shortId = (id: string) => (id.length > 10 ? `${id.slice(0, 8)}…` : id);

// The first in-app-looking stack line, for list rows.
export const stackHeadline = (stack?: string): string | undefined => {
  if (!stack) return undefined;
  const lines = stack.split("\n").map((l) => l.trim()).filter(Boolean);
  const frame = lines.find((l) => /^at |@/.test(l));
  return frame?.slice(0, 160);
};
